import * as types from "../actions/actiontypes";
import * as appUtilityFunction from "../../../infrastructure/apputilityfunctions";

const initialState = {
  documentId: null,
  showBulkUpload: false,
  matchTypes:[]
};

export default function bulkPhotoUpload(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_BULK_UPLOAD: {
      return {
        ...state,
        documentId: action.payload,
        showBulkUpload: true,
      };
    }
    case types.CLOSE_BULK_UPLOAD: {
      return {
        ...state,
        showBulkUpload: false,
      };
    }
    case types.INIT_END: {
      return {
        ...state,
        matchTypes: action.payload
      };
    }
    default:
      return state;
  }
}
